import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiCollectionsService } from '../../../../../services/collections/api/api-collections.service';
import { AlertsService } from '../../../../../services/alerts.service';
import { LanguagesService } from '../../../../../services/languages/languages.service';
import { CollectionReward } from '../../../../../models/collections/collection-reward.model';
import { UserCurrencyType } from '../../../../../enums/users/user-currency-type.enum';
import { CollectionTranslationForm, buildCollectionTranslationForms, toCollectionTranslations } from '../../../collection-translation-form.model';

@Component({
  selector: 'app-collection-album-add-modal',
  templateUrl: './collection-album-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class CollectionAlbumAddModalComponent {

  @Input() collectionId: number = 0;

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  name: string = '';
  translations: CollectionTranslationForm[] = [];
  rewards: CollectionReward[] = [];
  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(
    private apiCollectionsService: ApiCollectionsService,
    private alertsService: AlertsService,
    private languagesService: LanguagesService
  ) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.name = '';
    this.translations = buildCollectionTranslationForms(this.languagesService.languages);
    this.rewards = [];
    this.isLoading = false;
    this.modal.show();
  }

  addReward(): void {
    const r = new CollectionReward();
    this.rewards.push(r);
  }

  removeReward(index: number): void {
    this.rewards.splice(index, 1);
  }

  save(): void {
    this.isLoading = true;
    this.apiCollectionsService.addCollectionAlbum(this.collectionId, this.name, toCollectionTranslations(this.translations), this.rewards).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Album added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding album : ' + error);
      }
    );
  }
}
